
/**
 *  Should probably use lodash for functions like these as long as we only import the functions
 *  we would need.  Was having a problem getting it working.
 */
interface IThrottleOptions {
  leading?: boolean
  trailing?: boolean
}
export function throttle(func, wait, options: IThrottleOptions = {}, ...otherArgs) {
  let context
  let args: any[]
  let result
  let timeout: number = null
  let previous = 0
  function later() {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) {
      context = null
      args = null
    }
  }
  // need to use function instead of () =>, so we have the proper context of "this"
  return function main() {
    const now = Date.now()
    if (!previous && options.leading === false) {
      previous = now
    }
    const remaining = wait - (now - previous)
    context = this
    args = otherArgs
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) {
        context = null
        args = null
      }
    } else if (!timeout && options.trailing !== false) {
      timeout = window.setTimeout(later, remaining)
    }
    return result
  }
}

export function debounce(func, delay) {
  let inDebounce
  // need to use function instead of () =>, so we have the proper context of "this"
  return function main(...args) {
    const context = this
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() => func.apply(context, args), delay)
    return inDebounce
  }
}

export function arrayFind(arr: Array<any>, fn) {
  if (Array.prototype.find) {
    return arr.find(fn)
  }
  const index = arrayFindIndex(arr, fn)
  return index > -1 ? arr[index] : undefined
}

export function arrayFindIndex(arr: Array<any>, fn) {
  if (Array.prototype.findIndex) {
    return arr.findIndex(fn)
  }
  const list = Object(arr)
  // Makes sure always has an positive integer as length.
  const length = list.length >>> 0
  for (let i = 0; i < length; i++) {
    const element = list[i]
    if (fn.call(undefined, element, i, list)) {
      return i
    }
  }
  return -1
}

// This function copies properties from the 2nd object onto the first object and
// returns it.  It will copy nested values as well.
// NOTE: this is a shallow copy.  Changing object values in one, will change the other.
export function mergeProps(obj1, obj2) {
  Object.keys(obj2).forEach((k) => {
    if (obj2[k] && typeof obj2[k] === 'object' && !Array.isArray(obj2[k])) {
      if (!obj1[k]) {
        obj1[k] = {}
      }
      mergeProps(obj1[k], obj2[k])
    } else {
      obj1[k] = obj2[k]
    }
  })
  return obj1
}
